import {Serializers} from '../../interfaces/serializer';

export const DATA_SOURCE_PROVIDERS_STATE_NAME = 'dataSourceProviders';

export interface DataSourceProvider {
  name: string;
  icon: string;
  slug: string;
}

export interface DataSourceProvidersState {
  serialized: Serializers<DataSourceProvider>;
  componentObjects: Array<any>;
  loading: boolean;
  loaded: boolean;
}
